export function scrollToTop(): void {
  // casting is forced because the value "instant" is valid but not recognized by TS typing
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
}
